module.exports = __webpack_public_path__ + "img/Patch18-1.81610370.webp";